import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const HeaderLeftPortaled = ({ children }: { children: React.ReactNode }) => {
  const [container, setContainer] = useState<Element | null>(null);

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      setContainer(document.getElementById('header-left'));
    });
    return () => cancelAnimationFrame(raf);
  }, []);

  if (!container) return null;
  return createPortal(children, container);
};
